/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

// ==============================================================================
// Provides a generic tooltip.
// ------------------------------------------------------------------------------

(function($, window) {
	// Needs to be in sync with the variable $animSpeed in oktooltip.scss
	let animationSpeed = Modernizr.cssanimations ? 150 : 0;

	class OkTooltip {
		// Initialization functions
		// -----------------------------------------------

		// id - string - ID to assign to the tooltip.
		//
		// Required params:
		//		id (string)		 - ID of the tooltip
		//		message (string)	- Message text
		//		direction (string)  - Direction of the tooltip [top, right, bottom, left]
		//		target (obj) - jQuery object, or selector string
		//
		// Optional parameters in defaults object below
		//
		constructor(params) {
			if (
				params.id == null ||
				params.message == null ||
				params.direction == null ||
				params.target == null
			) {
				console.log("Insufficient parameters");
				return;
			}

			let defaults = {
				padding: 0,
				classes: "",
				inline: false,
			};
			$.extend(this, defaults, params);

			// If they passed a selector, get it.
			if (typeof this.target === "string") {
				this.target = $(params.target);
			}

			if (!this.target.length) {
				return;
			}

			// Template
			let classes = `oktooltip on_${this.direction}`;

			if (this.heading) {
				classes = `${classes} has_heading`;
			} else {
				this.heading = "";
			}

			if (!this.progress) {
				this.progress = "";
			}

			if (this.classes) {
				classes = `${classes} ${this.classes}`;
			}

			// if the tooltip has either the 'small' or the 'dark' class, institute a delay
			let defaultDelay = 0;
			if (classes.indexOf("small") !== -1 || classes.indexOf("dark") !== -1) {
				defaultDelay = 400;
				// Otherwise if it doesn't have a timeout, add the has_close class.
			} else if (!this.timeout && !this.progress && !this.noClose) {
				classes += " has_close";
			}

			this.delay = this.delay != null ? this.delay : defaultDelay;
			if (this.delay) {
				this.hasdelay = true;
				this.opener = null;
			}

			let markup = `\
<div id="${this.id}" class="${classes}">
	<div class="heading">
		<span class="title">${this.heading}</span>
		<span class="progress">${this.progress}</span>
		<button class="close_btn" type="button">
			<i class="icon i-close"></i>
		</button>
		<button class="next_btn" type="button">
			<i class="icon i-arrow-right"></i>
		</button>
		<button class="prev_btn" type="button">
			<i class="icon i-arrow-left"></i>
		</button>
	</div>
	<div class="msg">${this.message}</div>
	<div class="arrow"></div>
</div>\
`;

			// Place it at the body, for easier positioning and not dealing with overflow
			this.tooltip = $(markup);
			// Check if it exists, and if so, replace it.
			if ($(`#${this.id}`).length) {
				$(`#${this.id}`).replaceWith(this.tooltip);
			} else {
				if (this.inline) {
					$(this.target).parent().append(this.tooltip);
				} else {
					$("body").append(this.tooltip);
				}
			}

			this.tooltip = $(`#${this.id}`);
			this.center();

			// Bind the close button.
			this.tooltip.find(".close_btn").on("click tap", () => {
				// Make sure delay doesn't slow down the close from click time.
				let hadDelay = this.hasdelay;
				this.hasdelay = false;
				this.close();
				return (this.hasdelay = hadDelay);
			});
			// Bind the next / prev button
			this.tooltip.find(".next_btn").on("click tap", () => {
				return this.setStep(this.step + 1);
			});
			this.tooltip.find(".prev_btn").on("click tap", () => {
				return this.setStep(this.step - 1);
			});
			// Needs repositioning on resize since it's at the body.
			$(window).resize(() => {
				if (this.tooltip.hasClass("open")) {
					return this.center(true);
				}
			});
			// If the target's scroll parent isn't the document, we'll also need to
			// reposition on scroll.
			if (this.target.scrollParent() !== this.tooltip.scrollParent()) {
				this.target.scrollParent().scroll(() => {
					if (this.isOpen()) {
						return this.center(true);
					}
				});
			}

			return this;
		}

		// Event-based functions
		// -----------------------------------------------

		isOpen() {
			return this.tooltip.hasClass("open");
		}

		open(skipDelay) {
			if (!this.target.length) {
				return;
			}

			if (this.hasdelay && !skipDelay) {
				clearTimeout(this.opener);
				return (this.opener = setTimeout(() => {
					return this.openTooltip();
				}, this.delay));
			} else {
				return this.openTooltip();
			}
		}

		openTooltip() {
			this.center();
			this.tooltip.addClass("open");
			setTimeout(() => {
				// Prevent the open animation from playing again while it's open.
				return this.tooltip.addClass("no_open_animation");
			}, animationSpeed);
			// If timeout was set, close it after @timeout ms.
			if (this.timeout) {
				if (this.timeoutObj) {
					clearTimeout(this.timeoutObj);
				}
				this.timeoutObj = setTimeout(() => {
					return this.close();
				}, this.timeout);
			}

			if (typeof this.onOpen === "function") {
				this.onOpen();
			}

			return this;
		}

		close() {
			// if they're delayed, cancel the opener
			clearTimeout(this.opener);

			if (this.tooltip.hasClass("open")) {
				this.tooltip.addClass("closing").removeClass("open no_open_animation");
				setTimeout(() => {
					return this.tooltip.removeClass("closing");
				}, animationSpeed);
			}

			if (typeof this.onClose === "function") {
				this.onClose();
			}

			return this;
		}

		changeDirection(dir) {
			this.tooltip.removeClass(`on_${this.direction}`).addClass(`on_${dir}`);
			this.direction = dir;
			this.center();
			return this;
		}

		changeTarget(newTarget) {
			this.target = newTarget;
			if (this.inline) {
				this.target.after(this.tooltip);
			}
			this.center();
			return this;
		}

		changeMessage(newMsg) {
			this.tooltip.find(".msg").html(newMsg);
			this.center();
			return this;
		}

		changeHeading(newHeading) {
			this.tooltip.find(".heading .title").html(newHeading);
			if (newHeading) {
				this.tooltip.addClass("has_heading");
			} else {
				this.tooltip.removeClass("has_heading");
			}
			this.center();
			return this;
		}

		changePadding(padding) {
			this.padding = padding;
			this.center();
			return this;
		}

		// See @setStep for what the steps array objects should have.
		setSteps(steps) {
			this.steps = steps;
			this.step = 0;

			if (this.steps.length > 1) {
				this.tooltip.addClass("has_heading has_steps");
			} else {
				this.tooltip.removeClass("has_steps");
			}

			this.setStep(this.step);
			return this;
		}

		setStep(stepNum) {
			if (!this.steps) {
				return this;
			}
			this.step = stepNum.mod(this.steps.length);
			let config = this.steps[this.step];

			if (config.message) {
				this.changeMessage(config.message);
			}
			if (config.heading) {
				this.changeHeading(config.heading);
			}
			if (config.target) {
				this.changeTarget(config.target);
			}
			if (config.direction) {
				this.changeDirection(config.direction);
			}
			if (config.padding) {
				this.changePadding(config.padding);
			}

			if (typeof this.onStep === "function") {
				this.onStep(this.step);
			}

			return this;
		}

		// Determine position. Not exceptionally elegant.
		// noAnimation - Self explanitory, forces animation off.
		// force - Forces it center, even if not open.
		center(noAnimation) {
			if (!this.target.length) {
				return;
			}
			if (noAnimation) {
				this.tooltip.addClass("noanimation");
			}

			let { top } = this.target.offset();
			let { left } = this.target.offset();
			let elementWidth = this.target.outerWidth();
			let elementHeight = this.target.outerHeight();
			let tooltipWidth = this.tooltip.outerWidth();
			let tooltipHeight = this.tooltip.outerHeight();
			let arrowWidth = this.tooltip.find(".arrow").outerWidth();
			let arrowHeight = this.tooltip.find(".arrow").outerHeight();

			// if getting the size of the arrow failed, make it not display none and
			// try again
			if (arrowWidth === 0 || arrowHeight === 0) {
				this.tooltip.addClass("invisible");
				arrowWidth = this.tooltip.find(".arrow").outerWidth();
				arrowHeight = this.tooltip.find(".arrow").outerHeight();
				this.tooltip.removeClass("invisible");
			}

			if (this.inline) {
				top -= this.target.offsetParent().offset().top;
				left -= this.target.offsetParent().offset().left;
			}

			if (this.direction === "top" || this.direction === "bottom") {
				left = Math.floor(left + elementWidth / 2 - tooltipWidth / 2);
			} else if (this.direction === "left" || this.direction === "right") {
				top = Math.floor(top + elementHeight / 2 - tooltipHeight / 2);
			}

			if (this.direction === "right") {
				left = left + elementWidth + arrowHeight + this.padding;
			} else if (this.direction === "left") {
				left = left - tooltipWidth - arrowWidth - this.padding;
			} else if (this.direction === "bottom") {
				top = top + elementHeight + arrowHeight + this.padding;
			} else if (this.direction === "top") {
				top = top - tooltipHeight - arrowHeight - this.padding;
			}

			this.tooltip.css("top", top);
			this.tooltip.css("left", left);

			if (noAnimation) {
				this.tooltip.css("top");
				this.tooltip.css("left");
				this.tooltip.removeClass("noanimation");
			}

			return this;
		}
	}

	// Bind OkTooltip to the global scope.
	window.OkTooltip = OkTooltip;

	return window.QuickTooltip = {
		init() {
			// Check for elements with the 'data-tooltip' attribute, and bind one to them.
			this.quickTooltip = new OkTooltip({
				id: "quick_tooltip",
				message: "Placeholder",
				direction: "top",
				target: $("body"),
				classes: "small",

				onOpen: () => {
					return this.positionOnScreen();
				},
			});

			return this.listen();
		},

		listen() {
			$("body").on("mouseenter", "[data-tooltip]", e => {
				return this.open(e);
			});
			$("body").on("mouseleave", "[data-tooltip]", e => {
				return this.close();
			});
			$("body").on("mouseup", "[data-tooltip]", e => {
				if ($(e.currentTarget).is("[data-tooltip-ontap]")) {
					return;
				}
				return this.quickTooltip.close();
			});
			return $("body").on("tap", "[data-tooltip-ontap]", e => {
				this.open(e, true);
				return setTimeout(() => {
					return this.quickTooltip.close();
				}, 2000);
			});
		},

		open(e, noDelay) {
			let target = $(e.currentTarget);
			let msg = target.attr("data-tooltip");
			let direction = target.attr("data-tooltip-direction") || "top";
			let padding = parseInt(target.attr("data-tooltip-padding"), 10) || 0;
			let classes = target.attr("data-tooltip-classes") || "";

			this.quickTooltip.changeDirection(direction);
			this.quickTooltip.changeTarget(target);
			this.quickTooltip.changeMessage(msg);
			this.quickTooltip.changePadding(padding);
			this.addClasses(classes);

			// force a previous one closed
			this.quickTooltip.tooltip.removeClass("closing");
			return this.quickTooltip.open(noDelay);
		},

		addClasses(classes) {
			if (!classes) {
				return;
			}

			this.tmpClasses = classes;
			return this.quickTooltip.tooltip.addClass(classes);
		},

		close() {
			__guardMethod__(this.quickTooltip, "close", o => o.close());

			if (this.tmpClasses != null && this.tmpClasses) {
				this.quickTooltip.tooltip.removeClass(this.tmpClasses);
				return (this.tmpClasses = null);
			}
		},

		// Push the tooltip in if it's off-screen
		positionOnScreen() {
			let diff;
			let tooltipEl = this.quickTooltip.tooltip;
			let dir = this.quickTooltip.direction;
			let tooltipPosition = tooltipEl.position();
			let marginDir = "";
			let minPadding = 10;

			if (dir === "left" || dir === "right") {
				marginDir = "top";
				let windowHeight = $(window).height();
				let tooltipHeight = tooltipEl.height();
				if (tooltipPosition.top - minPadding < 0) {
					diff = tooltipPosition.top - minPadding;
				} else if (
					windowHeight <
					tooltipHeight + tooltipPosition.top + minPadding
				) {
					diff =
						windowHeight - (tooltipHeight + tooltipPosition.top + minPadding);
				}
			} else {
				marginDir = "left";
				let windowWidth = $(window).width();
				let tooltipWidth = tooltipEl.width();
				if (tooltipPosition.left - minPadding < 0) {
					diff = tooltipPosition.left - minPadding;
				} else if (
					windowWidth <
					tooltipWidth + tooltipPosition.left + minPadding
				) {
					diff =
						windowWidth - (tooltipWidth + tooltipPosition.left + minPadding);
				}
			}

			if (diff) {
				tooltipEl.css(`margin-${marginDir}`, diff + "px");
				let arrow = tooltipEl.find(".arrow");
				return arrow.css(
					`margin-${marginDir}`,
					-diff - arrow.outerWidth() / 2 + "px"
				);
			}
		},
	};
})(jQuery, window);

const QuickTooltip = window.QuickTooltip;
export default QuickTooltip;

function __guardMethod__(obj, methodName, transform) {
	if (
		typeof obj !== "undefined" &&
		obj !== null &&
		typeof obj[methodName] === "function"
	) {
		return transform(obj, methodName);
	} else {
		return undefined;
	}
}



// WEBPACK FOOTER //
// ./src/legacy/oktooltip.js